import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Imperiji",
  "description": "",
  "published": "2006-05-26T00:00:00.000Z",
  "redirect_from": ["/blog/imperiji/swizec/411"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ta teden sem odkril dve cudoviti stvari. Ena je browser based gaming, se pravi igra, ki se igra preko brskalnika, drugo pa cudovit strip.`}</p>
    <p>{`Nikoli si nisem mislil, da je igranje preko brskalnika res tako zanimivo, res da so drugi o tem govorili, vendar le kako bi lahko verjel predenj poskusim. Izkazalo se je, da je `}<a parentName="p" {...{
        "href": "http://imperiaonline.org"
      }}>{`Imperia Online`}</a>{` najboljsa mozna oblika MMORPG-ja. Ima vse dobre lastnosti, kot naprimer veliko igralcev in zanimivo igralnost, nima pa problemov, kot naprimer obveznost prezdeti neskoncne ure za racunalnikom, ko samo igras. Je odlicna igra za tiste, ki nimajo prav dosti casa in radi zraven pocnejo se kaj drugega. Edina slabost bi lahko bila, da ni nekega aktivnega igralnega nacina.`}</p>
    <p>{`Druga stvar, strip, je pa odlicni `}<a parentName="p" {...{
        "href": "http://www.cartoontomb.de/english/death.php"
      }}>{`Death & Maiden`}</a>{`, ki govori o Smrti in ji da zanimivo osebnost, ki je zacuda kompleksna in cisto proti neki obicajni predstavi, vendar pa hkrati doseze, da ni nekaksna klisejsko neumna parodija. Strip je zakljucil prvi del, kar je zalostno, ker je bil odlicen, drugi del pa, kljub temu, da je zelo spremenil nacin pripovedovanja in ton stripa, kaze velik potencial. Bomo videli...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      